import request from '@/plugin/axios'

export function launchAd (data) {
  return request({
    url: '/api/admin/launchAd',
    method: 'post',
    data: data
  })
}
export function launchRecord (data) {
  return request({
    url: '/api/admin/launchAd',
    method: 'get',
    params: data
  })
}
export function updateLaunchRecordState (data) {
  return request({
    url: '/api/admin/launchAd/' + data.id,
    method: 'put',
    data: data
  })
}
/**
 * 投放统计
 * @param {} data
 */
export function queryLaunchAdvertStatisticsData (data) {
  return request({
    url: '/api/admin/queryLaunchAdvertStatisticsData',
    method: 'get',
    params: data
  })
}
/**
 * 统计数据查询
 * @param {} data
 */
export function statisticsQuery (data) {
  return request({
    url: '/api/admin/queryStatisticsData',
    method: 'get',
    params: data
  })
}
/**
 * 统计数据查询明细
 * */
export function statisticsQueryDetail (data) {
  return request({
    url: '/api/admin/queryStatisticsDataDetail',
    method: 'get',
    params: data
  })
}
export function flowMainStatisticsQuery (data) {
  return request({
    url: '/api/admin/queryStatisticsData1',
    method: 'get',
    params: data
  })
}

export function approvateLaunchAdvert (data) {
  return request({
    url: '/api/admin/approvate_launch_advert',
    method: 'post',
    data: data
  })
}
export function launchApprovateRecord (data) {
  return request({
    url: '/api/admin/launchApprovateRecord',
    method: 'post',
    data: data
  })
}
export function approvateLaunchAdvertRecord (data) {
  return request({
    url: '/api/admin/approvate_launch_advert_record',
    method: 'post',
    data: data
  })
}
export function cancelLaunchAdvertRecord (data) {
  return request({
    url: '/api/admin/cancel_launch_advert_record',
    method: 'post',
    data: data
  })
}
export function flowMainDoStop (data) {
  return request({
    url: '/api/admin/flowMainDoStop',
    method: 'put',
    data: data
  })
}

export function queryLaunchTimeRecord (data) {
  return request({
    url: '/api/admin/queryLaunchTimeRecord',
    method: 'get',
    params: data
  })
}
